import React from "react";
import { Image, Toast } from "react-bootstrap";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
import pictureDE from "../../../../../images/Germany/20231009_Tabelle_3_1_DE.png";
import pictureEN from "../../../../../images/Germany/20231009_Tabelle_3_1_EN.png";
import pictureES from "../../../../../images/Germany/20231009_Tabelle_3_1_ES.png";

function TeilsicherheitsbeiwertFuerErmuedungDetails({ show, setShow }) {
  const { i18n } = useTranslation("translation");
  const nodeRef = React.useRef(null);
  return (
    <Draggable nodeRef={nodeRef}>
      <Toast
        ref={nodeRef}
        onClose={() => setShow(!show)}
        show={show}
        animation={false}
        style={{
          zIndex: 1000,
          backgroundColor: "white",
          position: "absolute",
          width: "auto",
          height: "auto",
        }}
      >
        <Toast.Header className="flex-row-reverse"></Toast.Header>
        <Toast.Body>
          <Image
            width={600}
            src={
              i18n.language === "de-DE"
                ? pictureDE
                : i18n.language === "es-ES"
                  ? pictureES
                  : pictureEN
            }
            alt=""
          />
        </Toast.Body>
      </Toast>
    </Draggable>
  );
}

export default TeilsicherheitsbeiwertFuerErmuedungDetails;
